<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="student_name" slot-scope="student">
          <div class="text-wrap">
            <div class="text-wrap">{{student.first_name +' '+ student.last_name}}</div>
          </div>
        </template>
       <template slot="order_date" slot-scope="order_date">
          <div class="text-wrap">
            <div class="text-wrap">{{moment(order_date).format('DD-MMM-YYYY')}}</div>
          </div>
        </template>
<!--        <template slot="code" slot-scope="code">
          <div class="text-wrap">
            <div class="font-weight-bold text-wrap">{{code}}</div>
            &lt;!&ndash; <div class="text-gray-4">{{user.position}}</div> &ndash;&gt;
          </div>
        </template>
        <template slot="name" slot-scope="name">
          <div class="text-wrap">
            <div class="font-weight-bold text-wrap">{{name}}</div>
            &lt;!&ndash; <div class="text-gray-4">{{user.position}}</div> &ndash;&gt;
          </div>
        </template>-->
<!--        <template slot="description" slot-scope="description">
          <div>{{description}}</div>
        </template>-->
<!--        <template slot="category" slot-scope="category">
          <div>{{category.name}}</div>
        </template>
        <template slot="school_class" slot-scope="school_class">
          <div>{{school_class ? school_class.name : null}}</div>
        </template>-->
        <template slot="action" slot-scope="record">
          <div class="text-nowrap">
<!--            <a-tooltip
              placement="top"
              title="Create inward transaction"
            >
            <a href="javascript:"  class="btn btn-sm btn-success mr-2" @click="showInwardTransactionModal(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fa-lg fe  fe-plus-square" />
              </span>
            </a>
            </a-tooltip>
            <a-tooltip
              placement="top"
              title="Create outward transaction"
            >
            <a href="javascript:" class="btn btn-sm btn-warning mr-2" @click="showOutwardTransactionModal(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fa-lg fe fe-minus-square" />
              </span>
            </a>
            </a-tooltip>-->
            <a-tooltip
              placement="top"
              title="View order items"
            >
              <a href="javascript:" class="btn btn-sm btn-success mr-2" @click="showOrderItemsTableModal(record)">
                <i class="fe fe-eye" />
              </a>
            </a-tooltip>
            <a-tooltip
              placement="top"
              title="Download bill"
            >
              <a href="javascript:" class="btn btn-sm btn-info mr-2" @click="generateBill(record)">
                <i class="fe fe-download" />
              </a>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>

    <order-details></order-details>
  </div>
</template>

<script>
import OrderDetails from '@/components/inventory/order/single'

import moment from 'moment'
import { downloadBill } from '../common'
// import axios from 'axios'

const columns = [
  { title: 'Order No.', width: 100, dataIndex: 'order_no', scopedSlots: { customRender: 'order_no' } },
  { title: 'Student Code', width: 100, dataIndex: 'student.student_code', scopedSlots: { customRender: 'student.student_code' } },
  { title: 'Student Name', width: 300, dataIndex: 'student', scopedSlots: { customRender: 'student_name' } },
  { title: 'Date', width: 100, dataIndex: 'order_date', scopedSlots: { customRender: 'order_date' } },
  { title: 'Total Amt. (Rs.)', width: 100, dataIndex: 'total_amount', scopedSlots: { customRender: 'total_amount' } },
  { title: 'Paid by', width: 100, dataIndex: 'paid_by', scopedSlots: { customRender: 'paid_by' } },
  { title: 'Actions', width: 210, className: 'text-right', scopedSlots: { customRender: 'action' } },
]
// const fakedata = [
//   { id: 1, name: 'Eletronics', description: 'Category for electronics items' },
//   { id: 2, name: 'Fashion', description: 'Category for Fashion items' },
//   { id: 3, name: 'Furniture', description: 'Category for Furniture items' }
// ]
// const exposedEvents = { OnSubmit: 'onsubmit', OnEdit: 'onedit', OnDelete: 'ondelete' }

export default {
  name: 'OrdersTable',
  components: {
    OrderDetails,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    rolesetting: { type: Object },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      showeditform: false,
      datatoedit: {},
      // data: [],
    }
  },
  /* mounted: function () {
    this.fetchdata()
  }, */
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    moment,
    showOrderItemsTableModal(record) {
      // download api call
      console.log(record)
      this.$eventBus.$emit('openViewOrderDetailsModal', record)
    },
    generateBill(record) {
      downloadBill(this.$http, record.id, record.student.student_code, record.order_no)
    },
    closeEditform() {
      this.showeditform = false
    },
  },
}
</script>

<style>

</style>
